import { render, staticRenderFns } from "./limitStop.vue?vue&type=template&id=68a79c99&"
import script from "./limitStop.vue?vue&type=script&lang=js&"
export * from "./limitStop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports